/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import { colors } from "@dotnet/telematics-design-system";

import SortAscIcon from "../../assets/customIcons/actions/SortAscIcon";
import SortDescIcon from "../../assets/customIcons/actions/SortDescIcon";
import { useStyles } from "./styles";

export interface TableSortLabelProps {
  isActive: boolean;
  children: ReactNode;
  isDescending: boolean | "";
  onSortClick: () => void;
}

const TableSortLabel = ({
  children,
  isActive,
  isDescending,
  onSortClick
}: TableSortLabelProps) => {
  const { textDark, textDisabled } = colors;

  const { mainSpan, iconCSS } = useStyles();

  const getColor = (direction: boolean) =>
    isActive && direction === isDescending ? textDark : textDisabled;

  return (
    <span onClick={onSortClick} css={css(mainSpan)}>
      {children}

      <span css={css(iconCSS)}>
        <SortAscIcon
          css={css({
            color: getColor(false)
          })}
        />

        <SortDescIcon
          css={css({
            color: getColor(true)
          })}
        />
      </span>
    </span>
  );
};

export default TableSortLabel;
